import { render, staticRenderFns } from "./visitSeparation.vue?vue&type=template&id=210774e4&"
import script from "./visitSeparation.vue?vue&type=script&lang=js&"
export * from "./visitSeparation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports